import React, { ButtonHTMLAttributes } from 'react';

import { Icon } from '../Icon';
import {
  Badge,
  Container,
  Data,
  DataRow,
  Note,
  StatCardAccent,
  Title,
  Trend,
} from './styles';

interface IStatCardTrend {
  label: string;
  direction?: 'up' | 'down';
}

interface IStatCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  data: string | number;
  note?: string;
  accent?: StatCardAccent;
  trend?: IStatCardTrend;
  badge?: string;
}

const StatCard: React.FC<IStatCardProps> = ({
  title,
  data,
  note,
  accent = 'primary',
  trend,
  badge,
  ...rest
}) => {
  return (
    <Container accent={accent} {...rest}>
      <Title>{title}</Title>
      <DataRow>
        <Data>{data}</Data>
        {!!badge && <Badge>{badge}</Badge>}
        {!!trend && (
          <Trend direction={trend.direction || 'up'}>
            <Icon
              name={
                trend.direction === 'down' ? 'trending_down' : 'trending_up'
              }
              size={16}
            />
            {trend.label}
          </Trend>
        )}
      </DataRow>
      {!!note && <Note>{note}</Note>}
    </Container>
  );
};

export { StatCard };
export type { StatCardAccent };
